'use strict';


export default function() {
	return {
		require: '^incident',
		link: postLink,
		scope: {},
	};

	function postLink(scope, element, attrs, $incident) {
		element.addClass('panel');
		scope.$incident = $incident;
		$incident.$ready.then(function() {
			scope.$watch('$incident.completed', function(value) {
				if (value) {
					element.addClass('panel-default');
					element.removeClass('panel-primary');
				} else {
					element.removeClass('panel-default');
					element.addClass('panel-primary');
				}
			})
		});
	}
}
